var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFClothes4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 164,
    viewBox: "0 0 128 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.7429 28.9313C84.7429 18.7549 90.7305 10.5129 98.1233 10.5129C104.6 10.5129 110.037 16.9047 111.198 25.399L121.279 86.5416C122.868 96.2134 118.469 105.801 111.443 108.072C104.416 110.343 97.4513 104.371 95.7405 94.6995L85.0484 32.6318C84.8447 31.4544 84.7429 30.2209 84.7429 28.9313Z",
    fill: "#7D7BC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.194 132.882L95.9846 96.1292C94.396 86.3733 98.7951 76.7856 105.821 74.5148C112.848 72.3282 119.874 78.2995 121.523 87.8871L128 125.397L103.194 132.882Z",
    fill: "#7D7BC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.194 132.882L100.934 121.36L126.045 113.791L128 125.397L103.194 132.882Z",
    fill: "#A6A6E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6236 32.6318L32.8704 94.6995C31.2207 104.371 24.1945 110.343 17.1682 108.072C10.142 105.801 5.74294 96.2134 7.33149 86.5416L17.4126 25.399C18.5735 16.9047 24.0112 10.5129 30.5487 10.5129C37.8804 10.5129 43.868 18.7549 43.868 28.9313C43.868 30.2209 43.7865 31.4544 43.6236 32.6318Z",
    fill: "#7D7BC7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.611084 125.397L7.08745 87.8871C8.79819 78.2995 15.7633 72.3282 22.7896 74.5148C29.8158 76.7856 34.2149 86.3733 32.6263 96.1292L25.4168 132.882L0.611084 125.397Z",
    fill: "#7D7BC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.611084 125.397L2.62731 113.791L27.6774 121.36L25.4168 132.882L0.611084 125.397Z",
    fill: "#A6A6E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.278 124.135H26.1497L26.6384 11.1016L51.1387 6.10352e-05L54.3613 2.13543L58.9878 3.41668L62.8432 3.84376L67.0841 3.41668L71.3251 2.13543L75.5778 6.10352e-05L102.278 11.438V124.135Z",
    fill: "#7D7BC7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.278 124.135H26.1497L26.6384 11.1015L56.289 31.1771L65.9275 26.4791L102.278 11.4379V124.135Z",
    fill: "#7D7BC7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6997 124.135L26.5164 44.5743",
    stroke: "#6666B2",
    strokeWidth: 2.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.607 124.135L101.545 44.5743",
    stroke: "#6666B2",
    strokeWidth: 2.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFClothes4);
export default __webpack_public_path__ + "static/media/f-clothes-4.7fc6adc66ebdb5232155ff612453947f.svg";
export { ForwardRef as ReactComponent };